import type { MediaItem } from "@/types/media";

export const tvShows: MediaItem[] = [
  {
    id: "tv-01",
    title: "云上迷城",
    type: "tv",
    genre: "悬疑",
    region: "中国大陆",
    year: 2025,
    rating: 8.5,
    director: "陆之明",
    actors: ["沈书言", "许晴岚", "崔昊然"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20tv%20series%20poster%20of%20a%20misty%20mountain%20city%20with%20a%20lone%20figure%20walking%2C%20deep%20indigo%20violet%20fog%20backdrop%20with%20warm%20orange%20window%20glow%2C%20minimalist%20mysterious%20key%20art%2C%20atmospheric%20mood%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-01&orientation=portrait",
    description:
      "一座终年云雾缭绕的山城，接连发生无法解释的失踪事件。前来调查的女刑警发现，所有线索都指向城市地下失踪多年的旧城遗址。",
    views: 1780000,
    updatedAt: "2026-10-11",
    tags: ["悬疑", "刑侦", "民俗"],
    duration: "全36集",
  },
  {
    id: "tv-02",
    title: "权谋之巅",
    type: "tv",
    genre: "古装",
    region: "中国大陆",
    year: 2024,
    rating: 8.9,
    director: "顾岚之",
    actors: ["崔昊然", "白芸溪", "沈书言"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20costume%20drama%20tv%20series%20poster%20of%20an%20emperor%20seated%20on%20a%20throne%20in%20a%20vast%20hall%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20candle%20glow%2C%20minimalist%20regal%20key%20art%2C%20solemn%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-02&orientation=portrait",
    description:
      "新帝登基，朝堂暗流涌动。昔日的挚友变成朝堂上的对手，一场关于忠诚、野心与家国的权谋博弈就此拉开帷幕。",
    views: 2460000,
    updatedAt: "2026-10-08",
    tags: ["古装", "权谋", "正剧"],
    duration: "全48集",
  },
  {
    id: "tv-03",
    title: "都市浮生记",
    type: "tv",
    genre: "都市",
    region: "中国大陆",
    year: 2026,
    rating: 8.0,
    director: "陆之明",
    actors: ["柳思彤", "赵敬尧", "姜雨薇"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20tv%20series%20poster%20of%20young%20professionals%20silhouetted%20against%20a%20glassy%20skyline%2C%20deep%20purple%20blue%20dusk%20backdrop%20with%20warm%20orange%20office%20glow%2C%20minimalist%20modern%20key%20art%2C%20busy%20urban%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-03&orientation=portrait",
    description:
      "五个合租在城中村的年轻人，各自怀揣梦想在城市里打拼。租房、加班、恋爱与迷茫交织，他们学着在浮生里找到自己的位置。",
    views: 1320000,
    updatedAt: "2026-10-10",
    tags: ["都市", "群像", "现实"],
    duration: "全40集",
  },
  {
    id: "tv-04",
    title: "医者仁心",
    type: "tv",
    genre: "医疗",
    region: "中国大陆",
    year: 2023,
    rating: 8.6,
    director: "周立坤",
    actors: ["唐正阳", "苏晚晴", "邓一鸣"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20tv%20series%20poster%20of%20doctors%20in%20a%20bright%20hospital%20corridor%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20light%20glow%2C%20minimalist%20clean%20key%20art%2C%20hopeful%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-04&orientation=portrait",
    description:
      "急诊科里每天都在上演生死时速。一群性格各异的医护人员，在高压与质疑中坚守初心，也在一次次抢救里重新理解生命。",
    views: 1090000,
    updatedAt: "2026-09-30",
    tags: ["医疗", "职业", "群像"],
    duration: "全32集",
  },
  {
    id: "tv-05",
    title: "边境线",
    type: "tv",
    genre: "犯罪",
    region: "美国",
    year: 2025,
    rating: 8.7,
    director: "Derek Nolan",
    actors: ["James Doyle", "Nina Brooks", "罗天宇"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20tv%20series%20poster%20of%20an%20agent%20patrolling%20a%20desert%20border%20at%20night%2C%20deep%20purple%20blue%20backdrop%20with%20warm%20orange%20searchlight%20glow%2C%20minimalist%20gritty%20key%20art%2C%20tense%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-05&orientation=portrait",
    description:
      "边境小镇的缉毒探员与走私集团斗智斗勇多年。当一名新人加入队伍，一桩被掩盖多年的内鬼案也随之浮出水面。",
    views: 1560000,
    updatedAt: "2026-10-06",
    tags: ["犯罪", "缉毒", "美剧"],
    duration: "全24集",
  },
  {
    id: "tv-06",
    title: "甜蜜陷阱",
    type: "tv",
    genre: "爱情",
    region: "韩国",
    year: 2024,
    rating: 8.1,
    director: "金泰旭",
    actors: ["孙语桐", "李承宇", "姜雨薇"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20romantic%20comedy%20tv%20series%20poster%20of%20a%20couple%20in%20a%20cozy%20bakery%2C%20deep%20indigo%20violet%20warm%20backdrop%20with%20orange%20bokeh%20glow%2C%20minimalist%20sweet%20key%20art%2C%20playful%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-06&orientation=portrait",
    description:
      "天才甜点师与毒舌美食评论家意外成为邻居。一场关于“假情侣”的约定，让两个互相看不顺眼的人一点点掉进真正的甜蜜。",
    views: 1240000,
    updatedAt: "2026-10-02",
    tags: ["爱情", "甜宠", "韩剧"],
    duration: "全16集",
  },
  {
    id: "tv-07",
    title: "东京夜行",
    type: "tv",
    genre: "悬疑",
    region: "日本",
    year: 2025,
    rating: 8.3,
    director: "松本健一",
    actors: ["藤原蓝", "罗天宇", "白芸溪"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20mystery%20tv%20series%20poster%20of%20a%20taxi%20driving%20through%20rainy%20tokyo%20streets%20at%20night%2C%20deep%20indigo%20violet%20neon%20backdrop%20with%20warm%20orange%20sign%20glow%2C%20minimalist%20noir%20key%20art%2C%20moody%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-07&orientation=portrait",
    description:
      "一名只在深夜出车的出租车司机，接连载到神秘的乘客。每位乘客都带着一段不为人知的秘密，拼起来是一张巨大的都市谜题。",
    views: 970000,
    updatedAt: "2026-09-28",
    tags: ["悬疑", "单元剧", "日剧"],
    duration: "全12集",
  },
  {
    id: "tv-08",
    title: "家族荣耀",
    type: "tv",
    genre: "家族",
    region: "香港",
    year: 2023,
    rating: 8.0,
    director: "何蔚然",
    actors: ["罗天宇", "许晴岚", "崔昊然"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20family%20business%20drama%20tv%20series%20poster%20of%20a%20grand%20family%20mansion%20at%20night%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20chandelier%20glow%2C%20minimalist%20elegant%20key%20art%2C%20tense%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-08&orientation=portrait",
    description:
      "老牌家族企业根基受到动摇，三位子女各怀心思争夺继承权。血脉亲情与商业利益激烈碰撞，一个家族的荣光与裂痕同时被照亮。",
    views: 860000,
    updatedAt: "2026-09-25",
    tags: ["家族", "商战", "港剧"],
    duration: "全30集",
  },
  {
    id: "tv-09",
    title: "星轨之下",
    type: "tv",
    genre: "科幻",
    region: "美国",
    year: 2026,
    rating: 8.4,
    director: "Marcus Lee",
    actors: ["Ryan Cole", "Amy Foster", "林知远"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20tv%20series%20poster%20of%20a%20space%20station%20orbiting%20a%20ringed%20planet%2C%20deep%20indigo%20violet%20cosmic%20backdrop%20with%20warm%20orange%20sun%20glow%2C%20minimalist%20modern%20key%20art%2C%20epic%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-09&orientation=portrait",
    description:
      "人类第一座环行星空间站建成，来自各国的移民在此共同生活。一次意外的事故，让站内的秩序与信任面临前所未有的考验。",
    views: 1870000,
    updatedAt: "2026-10-12",
    tags: ["科幻", "太空", "美剧"],
    duration: "全20集",
  },
  {
    id: "tv-10",
    title: "少年游侠",
    type: "tv",
    genre: "武侠",
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    director: "顾岚之",
    actors: ["崔昊然", "姜雨薇", "赵敬尧"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20wuxia%20tv%20series%20poster%20of%20a%20young%20swordsman%20leaping%20across%20bamboo%20forest%2C%20deep%20indigo%20violet%20mist%20backdrop%20with%20warm%20orange%20sunbeam%20glow%2C%20minimalist%20dynamic%20key%20art%2C%20heroic%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-10&orientation=portrait",
    description:
      "出身寒微的少年偶得绝世剑谱，从此踏上江湖。他要在门派纷争与家国情仇之间，闯出一个属于自己的侠义传说。",
    views: 1380000,
    updatedAt: "2026-10-05",
    tags: ["武侠", "古装", "成长"],
    duration: "全36集",
  },
  {
    id: "tv-11",
    title: "精英律师团",
    type: "tv",
    genre: "职场",
    region: "中国大陆",
    year: 2025,
    rating: 7.9,
    director: "陆之明",
    actors: ["唐正阳", "苏晚晴", "柳思彤"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20legal%20drama%20tv%20series%20poster%20of%20lawyers%20walking%20through%20a%20modern%20courthouse%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20light%20glow%2C%20minimalist%20sleek%20key%20art%2C%20professional%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-11&orientation=portrait",
    description:
      "一间顶尖律所里，新人律师在一次次棘手案件中快速成长。当利益与正义发生冲突，他必须决定自己究竟要成为怎样的律师。",
    views: 940000,
    updatedAt: "2026-09-29",
    tags: ["职场", "律政", "现实"],
    duration: "全38集",
  },
  {
    id: "tv-12",
    title: "迷雾庄园",
    type: "tv",
    genre: "悬疑",
    region: "英国",
    year: 2023,
    rating: 8.8,
    director: "Oliver Hart",
    actors: ["Eleanor Style", "James Doyle", "许晴岚"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20british%20mystery%20tv%20series%20poster%20of%20a%20gothic%20manor%20shrouded%20in%20fog%20on%20a%20moor%2C%20deep%20indigo%20violet%20misty%20backdrop%20with%20warm%20orange%20window%20glow%2C%20minimalist%20gothic%20key%20art%2C%20eerie%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-12&orientation=portrait",
    description:
      "一座与世隔绝的古老庄园，一场大雪封住了所有出路。当第一位客人离奇死亡，留在庄园里的每个人都成了嫌疑人。",
    views: 1020000,
    updatedAt: "2026-09-27",
    tags: ["悬疑", "本格推理", "英剧"],
    duration: "全8集",
  },
  {
    id: "tv-13",
    title: "青春拾光",
    type: "tv",
    genre: "青春",
    region: "中国大陆",
    year: 2026,
    rating: 8.1,
    director: "韩雪松",
    actors: ["白芸溪", "崔昊然", "姜雨薇"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20youth%20drama%20tv%20series%20poster%20of%20students%20on%20a%20school%20rooftop%20at%20sunset%2C%20deep%20indigo%20violet%20warm%20sky%20backdrop%20with%20orange%20sun%20glow%2C%20minimalist%20fresh%20key%20art%2C%20nostalgic%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-13&orientation=portrait",
    description:
      "高三那年，一群少年在题海与梦想之间跌跌撞撞。友情、暗恋与离别在同一个夏天发生，成为他们此后一生都怀念的光。",
    views: 1470000,
    updatedAt: "2026-10-11",
    tags: ["青春", "校园", "成长"],
    duration: "全28集",
  },
  {
    id: "tv-14",
    title: "皇城旧事",
    type: "tv",
    genre: "古装",
    region: "中国大陆",
    year: 2023,
    rating: 8.4,
    director: "周立坤",
    actors: ["沈书言", "苏晚晴", "邓一鸣"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20palace%20drama%20tv%20series%20poster%20of%20a%20court%20lady%20before%20a%20red%20palace%20wall%2C%20deep%20indigo%20violet%20backdrop%20with%20warm%20orange%20lantern%20glow%2C%20minimalist%20elegant%20key%20art%2C%20dramatic%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-14&orientation=portrait",
    description:
      "身世成谜的少女被选入宫中，本想安稳度日，却在深宫里卷入一场跨越两代的旧案。她要在步步惊心中，找出自己真正的来处。",
    views: 1160000,
    updatedAt: "2026-09-24",
    tags: ["古装", "宫廷", "复仇"],
    duration: "全42集",
  },
  {
    id: "tv-15",
    title: "深海之约",
    type: "tv",
    genre: "冒险",
    region: "韩国",
    year: 2025,
    rating: 8.2,
    director: "金泰旭",
    actors: ["李承宇", "孙语桐", "赵敬尧"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20adventure%20tv%20series%20poster%20of%20divers%20exploring%20a%20glowing%20underwater%20ruin%2C%20deep%20indigo%20violet%20ocean%20backdrop%20with%20warm%20orange%20glow%2C%20minimalist%20mysterious%20key%20art%2C%20wondrous%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-15&orientation=portrait",
    description:
      "一群海洋考古学家在深海古城发现了一块神秘石碑。随着探索深入，他们发现这座沉入海底的城市，似乎与人类文明起源有关。",
    views: 1280000,
    updatedAt: "2026-10-07",
    tags: ["冒险", "悬疑", "韩剧"],
    duration: "全16集",
  },
  {
    id: "tv-16",
    title: "白夜追光",
    type: "tv",
    genre: "刑侦",
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    director: "陆之明",
    actors: ["唐正阳", "林知远", "柳思彤"],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20crime%20investigation%20tv%20series%20poster%20of%20a%20detective%20studying%20a%20case%20board%20at%20night%2C%20deep%20purple%20blue%20backdrop%20with%20warm%20orange%20desk%20lamp%20glow%2C%20minimalist%20tense%20key%20art%2C%20suspenseful%20atmosphere%2C%20ultra%20detailed%20vertical%20portrait%20composition&width=600&height=900&seq=tv-16&orientation=portrait",
    description:
      "刑警队接到一桩没有尸体的凶案，唯一的线索是一段模糊的监控。随着调查推进，真相指向了一桩被刻意掩埋多年的冤案。",
    views: 1720000,
    updatedAt: "2026-10-09",
    tags: ["刑侦", "悬疑", "推理"],
    duration: "全34集",
  },
];